import {StatusEventDetails} from '@models/machine/status-event-signal/status-event-details';
import {StatusEventType} from '@constants/machine/status-event-signal/status-event-type.enum';

export class StatusEventPageEventDisplayDetails extends StatusEventDetails {
  signalName: string;
  signalLabel: string;
  timestamp: number;
  sortableType: string;


  constructor(signalName: string, signalLabel: string, timestamp: number, code: string, type: StatusEventType, description: string, metadata: Map<string, string>, localizations: Map<string, string>) {
    super(code, type, description, metadata, localizations);
    this.signalName = signalName;
    this.signalLabel = signalLabel;
    this.timestamp = timestamp;
    this.sortableType = this.getSortableType(type);
  }

  private getSortableType(type: StatusEventType) {
    switch (type) {
      case StatusEventType.FAILURE:
        return '1-F';
      case StatusEventType.WARNING:
        return '2-W';
      case StatusEventType.INHIBIT:
        return '3-IH';
      case StatusEventType.INFO:
        return '4-I ';
      case StatusEventType.DEBUG:
        return '5-D';
      default:
        return '6-NA';
    }
  }
}
